import { Skill } from '@/data/about';
import React from 'react';

export interface SkillCardProps {
    skill: Skill;
    className?: string;
}

export const SkillCard: React.FC<SkillCardProps> = ({ skill, className = '' }) => {
    return (
        <div
            className={`bg-vscode-bg-secondary border border-gray-600/30 rounded-lg p-6 hover:border-vscode-accent/50 transition-all duration-300 ${className}`}
        >
            <div className='text-center mb-4'>
                <div className='text-4xl mb-3'>{skill.icon}</div>
                <h3 className='text-xl font-semibold text-vscode-accent'>{skill.title}</h3>
            </div>
            <p className='text-vscode-text-muted text-sm leading-relaxed text-center'>{skill.description}</p>
        </div>
    );
};
